import isNotNil from "../../ldsh/isNotNil"
import type { HasAnnexPoints } from "../HasAnnexPoints.type"
import type { Entity } from "./index"

export default function isBeingAnnexed (entity : Entity) : boolean {
  return isNotNil((entity as HasAnnexPoints).ap_ent_id)
}